// extracted by mini-css-extract-plugin
export default {"root":"xZ61Y","normal":"_1r8Ud","tier-link":"_31Zna","tierLink":"_31Zna"};